export default "__VITE_ASSET__BbaLwMWG__"